var map = {
	"./Background1.png": 10215,
	"./Background2.png": 7564,
	"./Background3.png": 43477,
	"./Background4.png": 19706,
	"./Background5.png": 67459,
	"./Background6.png": 30600,
	"./EmptyData.png": 18185,
	"./ai-logo.png": 66184,
	"./change.png": 49620,
	"./i-building.png": 57542,
	"./i-calendar.png": 79808,
	"./i-check.png": 78148,
	"./i-copy-two.png": 70256,
	"./i-copy.png": 26925,
	"./i-download-two.png": 1975,
	"./i-download.png": 33318,
	"./i-search.png": 19162,
	"./i-star.png": 88334,
	"./i-star2.png": 5854,
	"./i-up.png": 69401,
	"./icon-recognition.png": 71061,
	"./icon-recognition2.png": 73283,
	"./icon-up.png": 83055,
	"./icon1_1.png": 79190,
	"./icon1_2.png": 60813,
	"./icon2_1.png": 27353,
	"./icon2_2.png": 13346,
	"./iconlist1.png": 66026,
	"./iconlist2.png": 15009,
	"./iconlist3.png": 46744,
	"./iconlist4.png": 21911
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85099;